import { FeedbackState } from './useFeedbackState';

const sessionStorageName = 'cabmun_widget_feedback';
const pulseField = 'cabmun_widget_feedback_pulse';

export const getFeedbackStorage = () => {
  const result = sessionStorage.getItem(sessionStorageName);
  if (result) return JSON.parse(result) as FeedbackState['values'];
  return null;
};

export const setFeedbackStorage = (values: FeedbackState['values']) => {
  const result = sessionStorage.setItem(sessionStorageName, JSON.stringify(values));
};

export const getFeedbackPulse = () => {
  const result = localStorage.getItem(pulseField);
  if (result) return JSON.parse(result) as boolean;
  return true;
};

export const setFeedbackPulse = (values: boolean) => {
  const result = localStorage.setItem(pulseField, JSON.stringify(values));
};
